import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatCurrency } from "@/common/utils/formatters";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { checkinEntryOptions } from "@/features/maintenance/features/workflows/constants/forwardings/steps/checkinEntry/checkinEntryOptions.constant";
import { maintenanceeForwardingsDirectiveEntryStateStatus } from "@/features/maintenance/features/workflows/constants/forwardings/steps/directiveEntry/maintenanceForwardingsDirectiveEntryStateStatus.constant";
import { MaintenanceForwardingSectionsProps } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { createElement } from "react";
import EstablishmentChoiceEntryProposal from "./Proposal";

const MaintenanceWorkflowForwardingDirectiveEntry = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-lg font-semibold">
            {maintenanceForwardingsDirectiveEntryKlasses[forwarding.directive_entry_type]?.label}
          </p>
        </div>

        <div>
          {maintenanceeForwardingsDirectiveEntryStateStatus[forwarding.status]?.component
            ? createElement(maintenanceeForwardingsDirectiveEntryStateStatus[forwarding.status].component!, { forwarding })
            : null}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.directive_entry?.total_value && (
            <ResumeItem
              label="Valor a receber pelo diagnóstico"
              value={formatCurrency(Number(forwarding.directive_entry?.total_value))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.directive_entry?.deadline_to_complete_in_days != null && (
            <ResumeItem
              label="Resposta esperada até"
              value={`${forwarding.directive_entry?.deadline_to_complete_in_days} dias`}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <div className="flex gap-3">
          {forwarding.checkin_entry_type && (
            <ResumeItem
              label="Tipo de transporte"
              value={checkinEntryOptions[forwarding.checkin_entry_type].title}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.checkin_entry.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </div>

      <EstablishmentChoiceEntryProposal
        forwarding={forwarding}
        proposal={forwarding.establishment_choice_entry.actual_proposal}
      />
    </Box>
  );
}

export default MaintenanceWorkflowForwardingDirectiveEntry;
